/**
* @name: AppFrameLayout
* @author: weiyong
* @date: 2022-10-02 21:00
* @description：frameHeader
* @update: 2022-10-02 21:00
*/

<template>
  <div class="w100b h100b"  :class="[prefixCls,getShowTabs?'hasTabs':'']">
    <frameHeader :showType="showType" :appId="appId" :back="back"></frameHeader>
    <MultipleTabs v-if="getShowTabs" />
    <frameBody  :itemMenu="itemMenu" :showApp="showApp" v-if="bodyFlag">
    </frameBody>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'appMain',
});
</script>

<script lang="ts" setup>
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import {getUrlParams, StorageUtils} from 'xmgoing-utils';
import {getAppObjById, getAppObjByTemplateId} from "@/api/sys/portalSpace";
import {useDesign} from "@/hooks/web/useDesign";
import {computed, nextTick, toRef, watch} from "vue";
import {useRouter} from "vue-router";
import {useSubAppInfos} from '@/hooks/layouts/useSubAppInfos';
import FrameHeader from './appFrameCom/frameHeader.vue';
import FrameBody from './appFrameCom/frameBody.vue';
import {onBeforeMount, ref, toRefs, unref} from 'vue';
import GoingUtils from "@/utils/goingUtils";
import MultipleTabs from '@/layouts/default/tabs/index.vue';
import {useFullContent} from "@/hooks/web/useFullContent";
import {useMultipleTabSetting} from "@/hooks/setting/useMultipleTabSetting";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {PageEnum} from "@/enums/pageEnum";

const dataSourceStore = useDataSourceStore();
const router = useRouter();
const itemMenu = ref({});


const { getFullContent } = useFullContent();

const { getShowMultipleTab } = useMultipleTabSetting();
const getShowTabs = computed(() => {
  return unref(getShowMultipleTab) && !unref(getFullContent);
});

const bodyFlag = ref(false);
const location = window.location.href;
//如果是应用预览 则默认不显示 而是根据message通知来进行展示
if (location.indexOf("/appShow") > 0) {
  bodyFlag.value = false;
} else {
  bodyFlag.value = true;
}
const {prefixCls} = useDesign('AppFrameLayout');
const pcSpaceStore = usePcSpaceStore();
const appId:any = ref('');

const props = defineProps({
  templateId:{
    type:String,
    default:''
  },
  appId:{
    type:String,
    default:''
  },
  showType:{
    type:String,
    default:''
  },
  showApp: {
    type: Boolean,
    default: false
  },
  back: {
    type: Boolean,
    default: true
  }
});
const {back,showType} = toRefs(props);


/**
 * 打开界面
 * @param item
 */
const openPage = ({item}, backFun) => {
  itemMenu.value = item;
  StorageUtils.addSessionItem('curAppItem', JSON.stringify(unref(item)));
  //如果模版预览 则appId为-1
  if(item.appId+""==='-1'){
    appId.value = getUrlParams("appId",true);
  }else{
    appId.value = item.appId;
  }
  //如果应用id不存在
  if((item.appId==null||item.appId==="null"||(item.appId+'')==='-1')&&sessionStorage.getItem("appId")){
    item.appId=sessionStorage.getItem("appId");
  }
  //如果模版应用id存在
  if((item.appId==null||item.appId==="null"||(item.appId+'')==='-1')&&sessionStorage.getItem("templateAppId")){
    item.appId=StorageUtils.getSessionItem("templateAppId");
  }
  const pageType = StorageUtils.getSessionItem(PageEnum.PAGE_TYPE);
  StorageUtils.addSessionItem("templateAppId",item.appId);
  //如果是应用预览 或者是 模版启用预览 则根据id获取空间信息
  if(pageType===PageEnum.APP_SHOW){
    //查询当前应用对应的门户信息
    pcSpaceStore.getPcSpaceByAppIdAction(item.appId,dataSourceStore).then(() => {
      StorageUtils.addSessionItem("curAppId", item.appId);
      nextTick(() => {
        router.push({path: '/dashboard/appMainPage'});
        backFun && backFun();
      })
    });
  }else{
    //查询当前应用对应的门户信息
    pcSpaceStore.getAppSpaceItemsAction(item.appId,dataSourceStore).then(() => {
      StorageUtils.addSessionItem("curAppId", item.appId);
      nextTick(() => {
        router.push({path: '/dashboard/appMainPage'});
        backFun && backFun();
      })
    });
  }

}


/**
 * 根据模版id 获取菜单相关信息
 */
const openPageByTemplateId = async function (templateId) {
  const item = await getAppObjByTemplateId(templateId + "");
  bodyFlag.value = true;
  if (item && item[0]) {
    openPage({item: item[0]}, () => {});
  }else{
    openPage({item: {}}, () => {});
  }
}

/**
 * 根据应用id 获取菜单相关信息
 * @param templateId
 */
const openPageByAppId = async function (appId) {
  const item = await getAppObjById(appId);
  StorageUtils.addSessionItem("appId",appId);
  bodyFlag.value = true;
  if (item && item[0]) {
    openPage({item: item[0]}, () => {});
  }
}


//界面挂载
onMounted(() => {
  //如果是模版预览 或者 是应用预览才需要执行
  if(unref(showType)){
    //判断是否存在模版id
    if(props.templateId){
      StorageUtils.addSessionItem("templateId",props.templateId)
      openPageByTemplateId(props.templateId);
    }else{
      openPageByAppId(props.appId);
    }
  }
})
defineExpose({openPage})

</script>
<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-AppFrameLayout';

.@{prefix-cls} {
  overflow: hidden;
  &.hasTabs{
    .vben-frameBody{
      height: calc(100% - 82px);
      .vben-frameSubMenu{
        height: calc(100% - 82px);
      }
    }
  }
}


</style>
